module.exports = __webpack_public_path__ + "img/基金会会员.b8f9b15d.png";